var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/*
 * Copyright (c) 2023 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author HyeongjinOH
 * @contact hjoh@detech.co.kr
 * @date 2023-04-20
 * @brief SEI 오늘의 점검 컴포넌트
 *
 ********************************************************************/
import { useCallback, useEffect, useState } from "react";
import { useRecoilState, useRecoilValue } from "recoil";
import { checkTypeState, curSchduleTreeState } from "../../../recoil/assessmentState";
import { dailyState, infoPop, itemInfoState } from "../../../recoil/userState";
import TodaysInspectionTree from "./TodaysInspectionTree";
import TodaysInspectionView from "./TodaysInspetionView";
import CheckMain from "@components/dashBoard/todaysInspection/checklist/CheckMain";
import DailyInfoToday from "@components/dashBoard/todaysInspection/days/DailyInfoToday";
import DailyInfoTodayDone from "@components/dashBoard/todaysInspection/days/DailyInfoTodayDone";
import InspectionInfo from "@components/dashBoard/todaysInspection/inspection/InspectionInfo";
import { useOutletContext } from "react-router-dom";
import * as CUTIL from "../../../utils/commUtils";
function TodaysInspectionMain() {
    // recoli
    const curTree = useRecoilValue(curSchduleTreeState);
    const dailyId = useRecoilValue(dailyState);
    const itemId = useRecoilValue(itemInfoState);
    const check = useRecoilValue(checkTypeState);
    const [infoPopId, setInfoPopId] = useRecoilState(infoPop);
    //props
    const { handleOpenPop } = useOutletContext();
    const [spgInfo, setSpgInfo] = useState([]);
    const [is1650M, setIs1650M] = useState(false);
    const [isMobile, setMobile] = useState(false);
    useEffect(() => {
        // resize handler
        function handleResize() {
            if (window.innerWidth <= 1650) {
                setIs1650M(true);
            }
            else {
                setIs1650M(false);
            }
            if (window.innerWidth <= 500) {
                setMobile(true);
            }
            else {
                setMobile(false);
            }
        }
        handleResize();
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);
    // isMobile 여부 랜더링 후 확인
    useDebounceEffect(() => __awaiter(this, void 0, void 0, function* () {
        if (window.outerWidth <= 1650) {
            setIs1650M(true);
        }
        if (window.innerWidth <= 500) {
            setMobile(true);
        }
    }), 100);
    useEffect(() => {
        // width 1650 상세정보 팝업
        if (is1650M) {
            const infoPop = document.getElementById(infoPopId);
            if (!CUTIL.isnull(infoPop)) {
                infoPop.classList.remove("m-hidden");
                infoPop.classList.add("popup-layer");
                infoPop.classList.add("js-layer");
                infoPop.classList.add("popup-type1");
                infoPop.setAttribute("style", `position: fixed; top:0; right:0 `);
                return;
            }
        }
        else {
            closePopup(infoPopId);
            return;
        }
    }, [spgInfo]);
    // 상세 정보 닫기
    const closePopup = useCallback((id) => {
        const infoPop = document.getElementById(id);
        var body = document.body;
        var dimm = body.querySelector(".dimm");
        if (!CUTIL.isnull(infoPop)) {
            infoPop.classList.add("m-hidden");
            infoPop.classList.remove("popup-layer");
            infoPop.classList.remove("js-layer");
            infoPop.classList.remove("popup-type1");
            infoPop.removeAttribute("style");
            if (!CUTIL.isnull(body))
                body.removeAttribute("style");
            if (!CUTIL.isnull(dimm))
                dimm.removeAttribute("style");
            setInfoPopId("");
            return;
        }
    }, []);
    return (_jsxs(_Fragment, { children: [!check.checkOn && (_jsxs("main", Object.assign({ className: "container type2" }, { children: [_jsx(TodaysInspectionTree, { setSpgInfo: setSpgInfo }), _jsxs("section", Object.assign({ className: "content wcal-296" }, { children: [curTree.zone.zoneId && _jsx(TodaysInspectionView, { curTree: curTree, handleOpenPop: handleOpenPop }), _jsx("article", Object.assign({ className: `box box-detailinfo m-hidden ${dailyId.status == 2 ? "bg-white" : ""}`, hidden: dailyId.type == "daily" && dailyId.status == 2 && check.assessmentInfo.isTempSave == true
                                    ? true
                                    : dailyId.id <= 0 && dailyId.scheduleId <= 0 && dailyId.type == "daily" && dailyId.status == 1
                                        ? true
                                        : itemId.id <= 0 && itemId.type == "device"
                                            ? true
                                            : false, id: "m-1650" }, { children: curTree.zone.zoneId &&
                                    dailyId.id > 0 &&
                                    dailyId.scheduleId > 0 &&
                                    dailyId.type == "daily" &&
                                    dailyId.status == 1 ? (_jsx(DailyInfoToday, { handleOpenPop: handleOpenPop, closePopup: closePopup })) : curTree.zone.zoneId &&
                                    dailyId.type == "daily" &&
                                    dailyId.status == 2 &&
                                    check.assessmentInfo.isTempSave == false ? (_jsx(DailyInfoTodayDone, { handleOpenPop: handleOpenPop, closePopup: closePopup })) : curTree.zone.zoneId && itemId.id > 0 && itemId.type == "device" ? (_jsx(InspectionInfo, { handleOpenPop: handleOpenPop, itemId: itemId, closePopup: closePopup })) : ("") }))] }))] }))), check.checkOn && _jsx(CheckMain, { handleOpenPop: handleOpenPop })] }));
}
export default TodaysInspectionMain;
export function useDebounceEffect(fn, waitTime, deps) {
    useEffect(() => {
        const t = setTimeout(() => {
            fn.apply(undefined, deps);
        }, waitTime);
        return () => {
            clearTimeout(t);
        };
    }, deps);
}
